import { roundLatLng } from '@/shared/lib/coords';
import type { LatLng } from '@/shared/types';

export const directionKeys = {
	all: ['directions'] as const,
	kakao: (
		routeId: string,
		origin?: LatLng | null,
		destination?: LatLng | null,
	) =>
		[
			...directionKeys.all,
			'kakao',
			routeId,
			...roundLatLng(origin),
			...roundLatLng(destination),
		] as const,
	graphHopper: (
		routeId: string,
		origin?: LatLng | null,
		destination?: LatLng | null,
	) =>
		[
			...directionKeys.all,
			'graphhopper',
			routeId,
			...roundLatLng(origin),
			...roundLatLng(destination),
		] as const,
};
